import React, { createContext, useState, useContext, ReactNode } from 'react';

type ViewType = 'grid' | 'list';

interface ViewContextType {
  currentView: ViewType;
  setCurrentView: React.Dispatch<React.SetStateAction<ViewType>>;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  clearRangeDateSearch: boolean;
  setClearRangeDateSearch: React.Dispatch<React.SetStateAction<boolean>>;
}

const ViewContext = createContext<ViewContextType | undefined>(undefined);

interface ViewProviderProps {
  children: ReactNode;
}

export const ViewProvider: React.FC<ViewProviderProps> = ({ children }) => {
  const [currentView, setCurrentView] = useState<ViewType>('grid');
  const [page, setPage] = useState<number>(1);
  const [clearRangeDateSearch, setClearRangeDateSearch] = useState<boolean>(false);

  return (
    <ViewContext.Provider value={{ 
      currentView, 
      setCurrentView, 
      page, 
      setPage, 
      clearRangeDateSearch, 
      setClearRangeDateSearch 
    }}>
      {children}
    </ViewContext.Provider>
  );
};

export const useView = (): ViewContextType => {
  const context = useContext(ViewContext);
  if (context === undefined) {
    throw new Error('useView must be used within a ViewProvider');
  }
  return context;
};